import { AvatarSize, AvatarType, ExAvatar, ExCard } from '@boomi/exosphere';
import styles from './HomeCard.module.css';
import { CheckCircle, Circle } from '@phosphor-icons/react';

interface HomeCardProps {
    name: string;
    showCheck: boolean;
    iconSrc: string | undefined;
    subtext?: string;
    onSelect: () => void;
}

const HomeCard = ({ name, showCheck, iconSrc, subtext, onSelect }: HomeCardProps) => {
    return (
        <ExCard className={styles.card} onClick={onSelect} aria-label={name}>
            <div className={styles.content}>
                <div className={styles.topRow}>
                    <div className={styles.iconWrap}>
                        {iconSrc ? (
                            <img src={iconSrc} alt={name} width={28} height={28} />
                        ) : (
                            <ExAvatar
                                size={AvatarSize.SMALL}
                                avatarType={AvatarType.USER}
                                firstName={name.split(' ')[0]}
                                lastName={name.split(' ')[1]}
                            />
                        )}
                    </div>
                    {showCheck ? (
                        <CheckCircle className={styles.enabledDot} size={18} weight="bold" />
                    ) : (
                        <Circle className={styles.disabledDot} size={18} weight="bold" />
                    )}
                </div>
                <div className={styles.name}>{name}</div>
                {subtext && <div className={styles.idp}>{subtext}</div>}
            </div>
        </ExCard>
    );
};

export default HomeCard;
